module.exports = __webpack_public_path__ + "static/media/popup2.538ad46c.svg";